/* istanbul ignore file */
import Text from './textDialog';
import TextAndCheckbox from './textAndCheckboxDialog';

export default {
  Text,
  TextAndCheckbox,
};
